import React from 'react'
import { Typography, Form, Input, Row, Col } from 'antd'
import AutoComplete from './autocomplete'
import useLocalStorage from '../utils/useLocalStorage'
import GoogleMapReact from 'google-map-react'
const { Title } = Typography

const Mappa = (props) => {
  const { value: location, setValue: setLocation } = useLocalStorage(
    {},
    'location'
  )
  return (
    <>
      <Title>Dove si trova l'appartamento?</Title>
      <Row gutter={[16, 16]}>
        <Col xs={24} sm={24} md={24} lg={12} span={12}>
          <Form.Item name="indirizzo" rules={[{ required: true }]}>
            <AutoComplete {...props} setLocation={setLocation} />
          </Form.Item>
          <Row gutter={24}>
            <Col xs={16} lg={18}>
              <Form.Item
                name="citta"
                wrapperCol={4}
                rules={[{ required: true }]}
              >
                <Input placeholder="Città" disabled />
              </Form.Item>
            </Col>
            <Col xs={8} lg={6}>
              <Form.Item name="CAP" wrapperCol={4}>
                <Input placeholder="CAP" disabled />
              </Form.Item>
            </Col>
          </Row>
        </Col>
        <Col xs={24} sm={24} md={24} lg={12} span={12}>
          <div
            className="w-full"
            style={{
              height: 420,
            }}
          >
            <GoogleMapReact
              bootstrapURLKeys={{
                key: 'AIzaSyAG9t0rJCf_Ef11QgicgPgXqXDgwLv9dCU',
              }}
              center={{
                lat: location.lat || 45.46362,
                lng: location.lng || 9.18812,
              }}
              draggable={false}
              zoom={location.lat && location.lng ? 18 : 11}
            >
              {location.lat && location.lng && (
                <i className="material-icons text-red-600 text-3xl">
                  location_on
                </i>
              )}
            </GoogleMapReact>
          </div>
        </Col>
      </Row>
    </>
  )
}

export default Mappa
